import PropTypes from "prop-types";
import React from "react";

import { useUserData } from "Flocknote/apiHooks";

import usePaymentMethodTypes from "Giving/ManageMyGivingPage/stateHooks/usePaymentMethodTypes";
import { useShowCCModal } from "Giving/ManageMyGivingPage/stateHooks/useShowCCModal";
import useRefetchMMGData from "Giving/ManageMyGivingPage/useRefetchMMGData";
import useStaxAPI from "Payments/AddPaymentMethod/CreditCardEntry/useStaxAPI";
import AddPaymentMethodModal from "Payments/ManagePaymentMethods/AddPaymentMethodModal";
import { ManagePaymentMethodsProvider, useManagePaymentMethods } from "Payments/ManagePaymentMethods/ManagePaymentMethodsContext";
import usePaymentMethods from "Payments/ManagePaymentMethods/stateHooks/usePaymentMethods";
import { useFetching } from "Payments/globalPaymentsStateHooks";

import usePaymentMethodData from "./hooks/usePaymentMethodData";

function Modal({ alerts, activeAlertID }) {
  const alert = alerts?.find((curAlert) => curAlert.ID === activeAlertID);
  const { state } = useManagePaymentMethods();
  const [, setPaymentMethods] = usePaymentMethods();
  const { fetchComplete } = useFetching();
  const [{ userID }] = useUserData();
  const [showCCModal, setShowCCModal] = useShowCCModal();
  const { loadStaxJs } = useStaxAPI();
  const { getPaymentMethodTypeById } = usePaymentMethodTypes();

  const refetchMMGData = useRefetchMMGData();

  const paymentMethods = state?.paymentMethods;
  const existingPaymentMethod = paymentMethods?.find((method) => {
    return method?.ID === alert?.userPaymentMethod?.ID;
  });
  const isAlreadyExisting = Object.keys(existingPaymentMethod || {}).length > 0;

  let staxIsLoaded = false;
  if (!staxIsLoaded) {
    staxIsLoaded = loadStaxJs();
  }

  usePaymentMethodData(userID);

  const clearAlerts = () => {
    refetchMMGData();
  };

  if (!fetchComplete || !staxIsLoaded) return null;

  return (
    <AddPaymentMethodModal
      show={showCCModal}
      setShow={setShowCCModal}
      userID={userID}
      existingPaymentMethod={existingPaymentMethod}
      hasOtherPaymentMethods={paymentMethods?.length > 1}
      isAlreadyExisting={isAlreadyExisting}
      mustSaveCard={true}
      initialPaymentType="card"
      setPaymentMethods={setPaymentMethods}
      onSuccess={clearAlerts}
      initialReplaceExistingCard={true}
      initialShouldRetokenize={true}
      showUpdateUI={true}
      initialAccountHolderType={alert?.userPaymentMethod?.accountHolderType?.toLowerCase()}
    />
  );
}

export default function UpdateACHModal({ alerts, activeAlertID }) {
  return (
    <ManagePaymentMethodsProvider>
      <Modal alerts={alerts} activeAlertID={activeAlertID} />
    </ManagePaymentMethodsProvider>
  );
}

let PTypes = {
  alerts: PropTypes.arrayOf(PropTypes.object),
  activeAlertID: PropTypes.number,
};
UpdateACHModal.propTypes = PTypes;
Modal.propTypes = PTypes;